<template>
  <b-table
    hover
    fixed
    :items="items"
    :fields="fields"
    :thead-class="{ 'd-none': depth > 0 }"
    v-if="items.length > 0"
  >
    <template #cell(hierarchyLabel)="row">
      <span
        class="subLevelLink"
        :class="{ 'pl-3': depth == 1, 'pl-4': depth == 2, 'pl-5': depth == 3 }"
        @click="row.toggleDetails"
        v-if="row.item.__children.length > 0"
      >
        {{ row.item.hierarchyLabel }}
        <b-icon-chevron-right
          :rotate="row.item._showDetails ? '90' : '0'"
        ></b-icon-chevron-right>
      </span>

      <span
        class="subLevelLink"
        :class="{ 'pl-3': depth == 1, 'pl-4': depth == 2, 'pl-5': depth == 3 }"
        v-else
      >
        {{ row.item.hierarchyLabel }}</span
      >
    </template>
    <template #row-details="row">
      <gwzTreeRow
        :items="row.item.__children"
        :fields="fields"
        :depth="depth + 1"
        v-if="row.item.__children.length > 0"
      >
      </gwzTreeRow>
    </template>

    <template #cell(actions)="row">
      <div class="float-right">
        <b-button
          size="sm"
          :to="{
            name: 'EditCategory',
            params: {
              id: row.item.id,
              hierarchyLabel: row.item.hierarchyLabel,
              hierarchyParentCode: row.item.hierarchyParentCode
            }
          }"
          class="mr-1"
        >
          Modifier
        </b-button>
      </div>
    </template>
  </b-table>
</template>

<script>
import gwzTreeRow from "@/components/gwzTreeRow.vue";

export default {
  name: "gwzTreeRow",
  components: {
    gwzTreeRow
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    },
    depth: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style>
.table {
  margin-bottom: 0 !important;
}

tr.b-table-details > td:first-of-type {
  padding: 0 0 !important;
}

tr.b-table-details {
  background-color: #fafafa !important;
}

.subLevelLink:hover {
  cursor: pointer;
}
</style>
